export const CLIENT_DOCUMENTS_LIST_QUERY = '/client-documents';
export const CLIENT_DOCUMENT_QUERY = '/client-documents/detail';
export const CLIENT_DOCUMENT_DOWNLOAD_URL_QUERY = '/client-documents/download';
